















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Modal from '@/app/ui/components/Modal/index.vue'
import TextInput from '@/app/ui/components/TextInput/index.vue'
import Button from '@/app/ui/components/Button/index.vue'

@Component({
  components: {
    Modal,
    TextInput,
    Button,
  },
})
export default class ModalCrrotwTaskGroupCancelReason extends Vue {
  @Prop({ type: Boolean, default: false }) readonly visible!: boolean
  @Prop({ type: String, required: true }) readonly statusLabel!: string
  @Prop({ type: Boolean, default: false }) readonly submitting!: boolean

  readonly minReasonLength = 10
  readonly maxReasonLength = 90

  reason = ''

  get trimmedReason(): string {
    return this.reason.trim()
  }

  get disableButton(): boolean {
    return this.trimmedReason.length < this.minReasonLength
  }

  @Watch('visible')
  onVisibleChange(v: boolean): void {
    if (!v) {
      this.resetReason()
    }
  }

  resetReason(): void {
    this.reason = ''
  }

  onCancel(): void {
    this.resetReason()
    this.$emit('cancel')
  }

  onConfirm(): void {
    if (this.disableButton || this.submitting) return
    this.$emit('confirm', this.trimmedReason)
  }
}
